export default "__VITE_ASSET__dce4cb11__"